import React, { useEffect } from 'react'
import styled from 'styled-components'
import { PageType } from '../../interfaces/types';

import slogan from './slogan.svg'
import name from './name.svg'
import daeho from './daeho.png'

const BackgroundBox = styled.div`
  position: fixed;
  top: 0;
  left: 0;

  width: 100%;
  height: 100%;

  background-color: #0548CB;

  z-index: 1000;
`

const OuterlineBox = styled.div`
  border: 3px solid white;
  
  position: fixed;
  
  top: 10px;
  left: 10px;
  right: 10px;
  bottom: 10px;
`

const InnerlineBox = styled.div`
  border: 1px solid white;

  position: fixed;

  top: 20px;
  left: 20px;
  right: 20px;
  bottom: 20px;
`

const IntroPage = (props: {
    setCurrentPage: (page: PageType) => void;
}) => {

    useEffect(() => {
      setTimeout(() => {
          props.setCurrentPage('SURVEY');
      }, 1500);
    })

  return (
    <BackgroundBox>
      <OuterlineBox>
        <InnerlineBox>
          <img
            style={{
              position: 'absolute',
              width: '70%',
              left: '20px',
              top: '20px'
            }}
            src={slogan}
            alt="당신의 친구, 90년생 직장인 성남시장"
          />
          <img
            style={{
              position: 'absolute',
              width: '100%',
              right: '0px',
              bottom: '0px'
            }}
            src={daeho}
            alt="이대호"
          />
          <img
            style={{
              position: 'absolute',
              width: '70%',
              maxHeight: '70vh',
              right: '20px',
              bottom: '20px'
            }}
            src={name}
            alt="기호 1번 이대호"
          />
        </InnerlineBox>
      </OuterlineBox>
    </BackgroundBox>
  )
}

export default IntroPage